export class ImageModel {
  constructor (data) {
    this.info = { active: data.active, type: data.type };
    this.uid = data.id;
    this.name = data.filename;
    this.status = 'done';
    this.url = data.imageURL;
  }
}
